import React from 'react';
import IndicatorTimelineWrapper from './IndicatorTimelineWrapper';
import { IndicatorTimelineContainer } from '../../../../../services/types/IndicatorTimeline';

interface Props {
  timelineContainer: IndicatorTimelineContainer;
  timelineWidth: number;
}

const IndicatorTimeline = (props: Props) => {
  const { timelineContainer, timelineWidth } = props;

  return (
    timelineContainer &&
    timelineWidth > 0 && (
      <IndicatorTimelineWrapper data={timelineContainer} timelineWidth={timelineWidth} />
    )
  );
};

export default IndicatorTimeline;
